import React      from 'react';
import classnames from 'classnames';
import _          from 'lodash';

const getPrice = (x, y, border) => {
  let price = 20 + (5 * (x - 1)) + (5 * (y - 1))

  if (border == 0.5) price += 10;
  if (border == 1.0) price += 20;
  return price;
};

const isSelected = (props) => {
  const length = _.ceil(props.parameters.get('stencil_length_text'));
  const width = _.ceil(props.parameters.get('stencil_width_text'));

  if (length > 10 || length <= 0 || width > 10 || width <= 0) {
    return false;
  }

  return props.row === width && props.col === length;
};

export default (props) => {
  const cellClass = classnames('price', { selected: isSelected(props) });
  let border = props.parameters.get('stencils_border')
  if (border) {
    border = parseFloat(border)
  }
  return (
    <td>
      <span className={cellClass}>{`$${getPrice(props.col, props.row, border)}`}</span>
    </td>
  );
};
